export const stateOptionsName = {
  disable_renewal: "Disable Renewal",
  disable_edit: "Disable Edit",
  disable_cancel: "Disable Cancellation",
  disable_international: "Disable International",
  disable_upgrade: "Disable Subscription Upgrade",
};
